import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema, headingsUISchema } from '../Header';
import templateView from './KeyValuePairTable';

const schema: JSONSchema7 = {
    title: 'Key Value Table',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        tableTitles: headingsSchema,
        tableItems: {
            type: 'array',
            title: 'Add Table Items',
            items: {
                type: 'object',
                properties: {
                    key: {
                        type: 'string',
                        title: 'Enter Key',
                    },
                    valueType: {
                        type: 'string',
                        enum: ['String', 'Placeholder'],
                        title: 'Select Value type',
                        default: 'String',
                    },
                    markerLabel: {
                        type: 'string',
                        title: 'Markers Label',
                        default: '',
                    },
                    showToolTip: {
                        type: 'boolean',
                        title: 'Show tooltip',
                        default: false,
                    },
                    uniqueListItemId: {
                        type: 'string',
                        title: 'Unique Id for list',
                        default: '',
                        description: 'Make sure id is unique across each list-item',
                    },
                },
                dependencies: {
                    showToolTip: {
                        oneOf: [
                            {
                                properties: {
                                    showToolTip: { enum: [true] },
                                    tooltipOptions: {
                                        title: 'Configure tooltip options',
                                        type: 'object',
                                        properties: {
                                            text: {
                                                type: 'string',
                                                title: 'Enter text',
                                            },
                                            iconName: {
                                                type: 'string',
                                                title: 'Enter tootltip icon',
                                                default: 'fas fa-info-circle',
                                            },
                                            backgroundColor: {
                                                type: 'string',
                                                title: 'Enter background color',
                                            },
                                        },
                                    },
                                },
                            },
                            {
                                properties: {
                                    showToolTip: { enum: [false] },
                                },
                            },
                        ],
                    },
                    valueType: {
                        oneOf: [
                            {
                                properties: {
                                    valueType: { enum: ['String'] },
                                    value: {
                                        type: 'string',
                                        title: 'Enter value',
                                    },
                                },
                            },
                            {
                                properties: {
                                    valueType: { enum: ['Placeholder'] },
                                },
                            },
                        ],
                    },
                },
            },
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransformData: {
                            type: 'string',
                            description: 'Function to transform Data',
                            default: 'return (data) => { return data}',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['tableTitles', 'tableItems'],
        'Transform Data': ['transformData', 'functionToTransformData'],
        Accessibility: ['disableTabStaticData'],
    },
];

const KeyValuePairTableWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        tableItems: {
            items: {
                'ui:field': 'CollapsibleFieldTemplate',
                valueType: { 'ui:widget': 'radio' },
                key: {
                    'ui:widget': 'ResourcePicker',
                },
                value: {
                    'ui:widget': 'ResourcePicker',
                },
                markerLabel: {
                    'ui:widget': 'ResourcePicker',
                },
                showToolTip: {
                    'ui:widget': 'CustomCheckbox',
                },
                tooltipOptions: {
                    text: {
                        'ui:widget': 'ResourcePicker',
                    },
                    iconName: {
                        'ui:widget': 'ResourcePicker',
                    },
                    backgroundColor: {
                        'ui:widget': 'ColorPicker',
                    },
                },
                uniqueListItemId: { 'ui:widget': 'ResourcePicker' },
            },
        },
        functionToTransformData: { 'ui:widget': 'JSEditor' },
        tableTitles: {
            ...headingsUISchema,
        },
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView,
    id: 'KeyValuePairTable',
    group: 'table',
    contentPlaceHolders: [],
    initialData: () => ({
        tableItems: [
            { key: 'sampleKey1', valueType: 'String', value: 'sampleValue1' },
            { key: 'sampleKey2', valueType: 'String', value: 'sampleValue2' },
            { key: 'sampleKey3', valueType: 'String', value: 'sampleValue3' },
        ],
    }),
};

export default KeyValuePairTableWidget;
